import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

Office.onReady(() => {
  const container = document.getElementById('root');
  if (container) {
    createRoot(container).render(<App />);
  }
});
